import React from "react";
import Create from "modules/merchants/components/Create";

const MerchantCreatePage = () => {
  return (
    <div>
      <Create />
    </div>
  );
};

export default MerchantCreatePage;
